<template>
    <div class="containerRepresentante">

         <div class="formulario">

           <div class="titleForm" style="display: inline-flex">
              <div style="width: 90%">

              <LabelDisclaimer :TamanhoFonteLabel="'H3'" :NomeLabel="'Pessoas Politicamente Expostas'" :TipoCliente="'Pessoa Física'" :Sessao="'Informação do Cliente'" :SubSessao="'Dados pessoais'"/>

              </div>
              <div  v-if="listaPEP.length > 0" style="width: 10%; margin-top: 10px;">
              <button class="btnBlue" @click="incluirPessoa">+ Adicionar</button>
              </div>
           </div>
           <div class="resumoForm">
            <div class="opcoesForm" v-if="listaPEP.length == 0">
                <img src="@/assets/addRepresentante.png" />
                <h3>Nenhuma pessoa adicionada</h3>
                <h5>Você pode adicionar quantas pessoas desejar</h5>
                <button class="btnBlue" @click="incluirPessoa">+ Adicionar</button>
            </div>
            <div v-if="listaPEP.length > 0">
              <table class="table">
                <thead>
                  <th style="width: 20%">Nome</th>
                  <th style="width: 20%">CPF/CNPJ</th>
                  <th style="width: 20%">Cargo/Orgão</th>
                  <th style="width: 25%">Grau de relacionamento</th>
                  <th style="width: 20%">&nbsp;</th>
                </thead>
                <tbody>
                  <tr v-for="(representanteObj, index) in listaPEP" :key="index">
                    <td>{{representanteObj.Nome}}</td>
                    <td>{{formatCpfCnpj(representanteObj.Cpf)}}</td>
                    <td>{{representanteObj.Cargo}}</td>
                    <td>{{representanteObj.GrauRelacionamento}}</td>
                    <td>
                      
                     <div class="widget icons" style="display: inline-flex">

                                        <a
                                            @click.stop.prevent="
                                                editarRepresentante(index)
                                            "
                                            class="ico__edit"
                                            title="editar"                                            
                                        >
                                            <Icon icon="ico-edit" />
                                            
                                        </a>
                                        <!-- v-if="politicaSelecionada == null || (politicaSelecionada != null && politicaSelecionada.guid == item.guid)" -->
                                     <a 
                                        @click.stop.prevent="deletarRepresentante(index)"
                                        class="ico__delete"
                                        title="deletar"    
                                        style="margin-left: 5px" 
                                    >
                                    </a>
                                     </div>


                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
           </div>

         </div>

           <ModalAddIncluirPep />

    </div>

    
</template>


<script>

import { mapGetters } from 'vuex';
import ModalAddIncluirPep from './ModalAddIncluirPep.vue'
import formatCpfCnpj from '@/utils/formatCpfCnpj'
import LabelDisclaimer from '@/components/LabelDisclaimer.vue'
import api from '@/api/axios';

export default {
    name: 'RepresentanteFatca',
    props: ['Edicao'],
    mixins: [formatCpfCnpj],
    components: { ModalAddIncluirPep, LabelDisclaimer },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            listaPEP: 'GET_LISTA_PEP_FI'
        }),
    },
    data() {
      return{

      };
    },
    created(){
       this.$store.dispatch('FETCH_FI_LISTA_PEP');
    },
    mounted(){
        this.$store.commit('SET_MODAL_PJ_ADD_PESSOA_PEP', false);
    },
    methods: {
      salvarInformacoes(){
        this.$store.commit('SET_PF_SALVAR_INFO', true);
      },
      incluirPessoa(){
        this.$store.commit('SET_MODAL_PJ_ADD_PESSOA_PEP', true);
      },
      editarRepresentante(index)
      {
        this.$store.commit('SET_MODAL_PJ_EDITAR_PESSOA_PEP', this.listaPEP[index]);
        this.$store.commit('SET_MODAL_PJ_ADD_PESSOA_PEP', true);
      },
      async deletarRepresentante(index){
             this.disableBtn = true;
              

                await  api.get(`fundo/facta/excluir?guid=${this.listaPEP[index].Guid}` )
                    .then((retorno) => {
                          
                        if(retorno.status == 200)
                        {

                          this.$swal({
                              icon: 'success',
                              title: 'Exclusão realizada com sucesso!',
                              text: 'Dados informados foram excluídos com sucesso.',
                          });

                          this.$store.dispatch('FETCH_FI_LISTA_REPRESENTANTES');

                        }
                    })
                    .catch((error) => {
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos.',
                            text: `${error.response.data.data[0]}`,
                        });
                    });

        }

    }
}

</script>


<style lang="scss" scoped>

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

 
</style>